<template>
  <div style="margin-top: -10px;">

    <v-container fluid fill-height >      
       <h1 class="mb-0">สมัครสมาชิก สถาบันยานยนต์ </h1><!--{{curr}} -->      

      <v-stepper v-model="curr" color="green" width="100%" class="elevation-0">
        <v-stepper-header class="overflow-x-auto">
                    <v-stepper-step
                        v-for="(step,n) in steps"
                        :key="n"
                        :complete="stepComplete(n+1)"
                        :step="n+1"
                        :rules="[value => !!step.valid]" 
                        :color="stepStatus(n+1)">
                        {{ step.name }}
                    </v-stepper-step>
        </v-stepper-header>
        <v-stepper-content v-for="(step, n) in steps" :step="n + 1" :key="n" >
              <!-- {{ step.name }}  -->
              <!-- stepp 1 -->
              <v-card v-if="curr===1"  class="mb-12" height="100%" elevation="0" >
                <v-card-text>
                  <v-form :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height>
                        <v-row no-gutters >
                            <v-col cols="12" sm="6" class="pr-2">
                              <v-select
                                v-model="itemSelected.Member_Type"
                                :items="Member_Type"
                                :rules="rules.Member_Type"
                                dense
                                filled
                                ref="Member_Type"                          
                                label="ประเภทสมาชิก/Member Type *"
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" class="pr-2">
                              <v-text-field
                              ref="TradeCode"
                              maxlength="13"
                              counter="13"
                              label="เลขที่กระทรวงพาณิชย์ *"
                              v-model="itemSelected.TradeCode"
                              :rules="rules.TradeCode"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>              
                          <v-col cols="12" sm="2" class="pr-2">
                            <v-select
                              v-model="itemSelected.Member_Title"
                              :items="Member_Title"
                              :rules="rules.Member_Title"
                              ref="Member_Title"
                              label="คำนำ/PreName *"
                              dense
                              filled
                            >
                            </v-select> 

                          </v-col>
                        <v-col cols="12" sm="5" class="pr-2">
                            <v-text-field
                              ref="Name_Com_th"
                              label="ชื่อบริษัท (ภาษาไทย) *"
                              v-model="itemSelected.Name_Com_th"
                              :rules="rules.Name_Com_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="5" class="pr-2">
                            <v-text-field
                              ref="Name_Com_en"
                              label="ชื่อบริษัท (English) *"
                              v-model="itemSelected.Name_Com_en"
                              :rules="rules.Name_Com_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>                     
                        
                          </v-row> 
    
                          <!--Start term -->
                            <v-row align="center"
                                justify="center">
                                <v-col cols="12" sm="4" class="pr-2" style="margin-top: -20px;">
                                    <v-checkbox ref="agree" label=" ยอมรับ " v-model="itemSelected.agree" :rules="rules.agree"   />

                                    <term
                                    :itemSelected="itemSelected"
                                    style="margin-left: 100px;  margin-top: -64px;"                            
                                    >                            
                                    </term>
                                </v-col>
                            </v-row>
                            <!-- start preview pdf -->
                              <!-- <v-row style="margin-top: -20px;">
                                        <v-col cols="12" sm="8" class="pr-2" >
                                          <h3>ตรวจสอบข้อมูลการสมัครสมาชิกสถาบันยานยนต์</h3>
                                          <v-btn @click="previewShow(itemSelected)">Preview PDF</v-btn>
                                        </v-col>                                
                              </v-row> -->

                            <!-- End preview pdf -->
                          <!--End term -->
                          <!--Send mail -->
                          <!-- <v-btn 
                             class="orange darken-4 white--text mx-2" :readonly="!formValid" @click="AppvMessage">send mail</v-btn> -->
                          <!--Send mail -->   
                  </v-form>           
                </v-card-text>
              </v-card>

              <!-- stepp 2 -->
              <v-card  class="mb-12" height="100%" elevation="0" >
                  <v-form v-if="curr===2" :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height class="elevation-0" >
                    <v-row no-gutters >
                      <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-top: 0px;"><span class="white--text" style="margin-left: 0px;">สถานที่ตั้ง (ภาษาไทย)</span></div>
                      </v-col>
                          <!-- สถานที่ตั้ง (ภาษาไทย)
                          -->

                          <v-col cols="12" sm="1" class="pr-2">                        
                            <v-text-field
                              ref="AddressNumber_th"
                              label="เลขที่ *"
                              v-model="itemSelected.AddressNumber_th"
                              :rules="rules.AddressNumber_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Moo_th"
                              label="หมู่"
                              v-model="itemSelected.Moo_th"
                              :rules="rules.Moo_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Building_th"
                              label="อาคาร/หมู่บ้าน"
                              v-model="itemSelected.Building_th"
                              :rules="rules.Building_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Floor"
                              label="ชั้น"
                              v-model="itemSelected.Floor"
                              :rules="rules.Floor"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Soi_th"
                              label="ซอย"
                              v-model="itemSelected.Soi_th"
                              :rules="rules.Soi_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Road_th"
                              label="ถนน"
                              v-model="itemSelected.Road_th"
                              :rules="rules.Road_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="2" class="pr-2">
                            <v-text-field
                              ref="Tambon_th"
                              label="แขวง/ตำบล *"
                              v-model="itemSelected.Tambon_th"
                              :rules="rules.Tambon_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Amphur_th"
                              label="เขต/อำเภอ *"
                              v-model="itemSelected.Amphur_th"
                              :rules="rules.Amphur_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Province_th"
                              label="จังหวัด *"
                              v-model="itemSelected.Province_th"
                              :rules="rules.Province_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Zipcode"
                              counter="5"
                              maxlength="5"
                              label="ไปรษณีย์ *"
                              v-model="itemSelected.Zipcode"
                              :rules="rules.Zipcode"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Industrial_estate_th"
                              label="นิคมอุตสาหกรรม"
                              v-model="itemSelected.Industrial_estate_th"
                              :rules="rules.Industrial_estate_th"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>
                          <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-top: -5px;"><span class="white--text" style="margin-left: 5px;">สถานที่ตั้ง (ภาษาอังกฤษ)</span></div>
                          </v-col>

                          <!-- 
                            สถานที่ตั้ง (ภาษาอังกฤษ)
                          -->

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="AddressNumber_en"
                              label="No *"
                              v-model="itemSelected.AddressNumber_en"
                              :rules="rules.AddressNumber_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Moo_en"
                              label="Moo"
                              v-model="itemSelected.Moo_en"
                              :rules="rules.Moo_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Building_en"
                              label="Building"
                              v-model="itemSelected.Building_en"
                              :rules="rules.Building_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Floor1"
                              label="Floor"
                              v-model="itemSelected.Floor"
                              :rules="rules.Floor1"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Soi_en"
                              label="Soi"
                              v-model="itemSelected.Soi_en"
                              :rules="rules.Soi_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Road_en"
                              label="Road"
                              v-model="itemSelected.Road_en"
                              :rules="rules.Road_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="2" class="pr-2">
                            <v-text-field
                              ref="Tambon_en"
                              label="Sub-District *"
                              v-model="itemSelected.Tambon_en"
                              :rules="rules.Tambon_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Amphur_en"
                              label="District *"
                              v-model="itemSelected.Amphur_en"
                              :rules="rules.Amphur_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Province_en"
                              label="Province *"
                              v-model="itemSelected.Province_en"
                              :rules="rules.Province_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Zipcode1"
                              counter="5"
                              maxlength="5"
                              label="Post code *"
                              v-model="itemSelected.Zipcode1"
                              :rules="rules.Zipcode1"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Industrial_estate_en"
                              label="Industrial Estate"
                              v-model="itemSelected.Industrial_estate_en"
                              :rules="rules.Industrial_estate_en"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-top: -5px;" ><span class="white--text" style="margin-left: 5px;">ติดต่อ</span></div>
                          </v-col>

                          <v-col cols="12" sm="3" class="pr-2">
                            <v-text-field
                              ref="Tel"
                              label="โทรศัพท์/Tel *"
                              v-model="itemSelected.Tel"
                              :rules="rules.Tel"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="1" class="pr-2">
                            <v-text-field
                              ref="Ext"
                              label="Ext"
                              v-model="itemSelected.Ext"
                              :rules="rules.Ext"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="4" class="pr-2">
                            <v-text-field
                              ref="Email"
                              label="Email *"
                              v-model="itemSelected.Email"
                              :rules="rules.Email"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="4" class="pr-2">
                            <v-text-field
                              ref="Website"
                              label="Website"
                              v-model="itemSelected.Website"
                              :rules="WebsiteRules"
                              :dense="text_filled"
                              :filled="text_filled"
                              required
                            />
                          </v-col>

                          <v-col cols="12" sm="6" class="pr-2" hidden>
                            <date-input
                              ref="InsertDate"
                              label="_InsertDate_"
                              v-model="itemSelected.InsertDate"
                              :rules="rules.InsertDate"
                              starttoday="false"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" class="pr-2" hidden>
                            <date-input
                              ref="ModifyDate"
                              label="_ModifyDate_"
                              v-model="itemSelected.ModifyDate"
                              :rules="rules.ModifyDate"
                              starttoday="false"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>

                          <v-col cols="12" sm="6" class="pr-2" hidden>
                            <v-textarea
                              ref="ModifyCode"
                              counter="255"
                              label="_ModifyCode_"
                              v-model="itemSelected.ModifyCode"
                              :rules="rules.ModifyCode"
                              :dense="text_filled"
                              :filled="text_filled"
                            />
                          </v-col>
                    </v-row>
                  </v-form>
                  
              </v-card>

              <!-- stepp 3 -->
              <v-card  class="mb-12" height="100%" elevation="0" style="margin-top: -40px;">
                  <v-form v-if="curr===3" :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height class="elevation-0">
                    <v-col cols="12" sm="12" hidden>
                      <v-row no-gutters>
                        <v-col cols="12" sm="6" class="pr-2">
                          <v-text-field counter="20" :dense="text_filled" :filled="text_filled"
                            label="_MemberCode_"
                            v-model="itemSelected.MemberCode"
                            :rules="rules.MemberCode"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" class="pr-2" hidden>
                      <v-text-field ref="TradeCode" counter="20" label="_TradeCode_" v-model="itemSelected.TradeCode" :rules="rules.TradeCode" :dense="text_filled" :filled="text_filled" />
                    </v-col>

                    <v-col cols="12" sm="12" class="pr-2" hidden>
                      <v-text-field ref="Contact_type" counter="100" label="_Contact_type_" v-model="itemSelected.Contact_type" :rules="rules.Contact_type" :dense="text_filled" :filled="text_filled" />
                    </v-col>


                    <v-col cols="12" sm="12" class="pr-2">
                      <div>
                            <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
                                <v-expansion-panel >
                                  <v-expansion-panel-header><strong>ผู้บริหารระดับสูง (ข้อมูลจำเป็น) *</strong></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                  <!-- content -->
                                    <v-row>
                                        <v-col cols="12" sm="1" class="pr-2">
                                        <!-- <v-text-field ref="TitleName_th" counter="100" label="_TitleName_th_" v-model="itemSelected.TitleName_th" :rules="rules.TitleName_th" :dense="text_filled" :filled="text_filled" /> -->
                                        <v-combobox :items="TitleName_th0" dense filled hide-selected ref="TitleName_th0" 
                                        label="คำนำ *" v-model="itemSelected.TitleName_th0" :rules="rules.TitleName_th0" @input="handleThaiTitleInput0"  />

                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field   ref="Name_th0" label="ชื่อ *" v-model="itemSelected.Name_th0" :rules="rules.Name_th0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_th0" label="นามสกุล *" v-model="itemSelected.LastName_th0" :rules="rules.LastName_th0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_th0" label="ตำแหน่ง *" v-model="itemSelected.Position_th0" :rules="rules.Position_th0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="1" class="pr-2">
                                          <v-combobox :items="TitleName_en0" dense filled hide-selected ref="TitleName_en0" label="Prename *" v-model="itemSelected.TitleName_en0" :rules="rules.TitleName_en0" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="Name_en0" label="Firstname *" v-model="itemSelected.Name_en0" :rules="rules.Name_en0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_en0" label="Lastname *" v-model="itemSelected.LastName_en0" :rules="rules.LastName_en0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_en0" label="Position *" v-model="itemSelected.Position_en0" :rules="rules.Position_en0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <!-- <v-text-field ref="Email0" label="E-Mail" v-model="itemSelected.Email" :rules="rules.Email0" :dense="text_filled" :filled="text_filled" /> -->
                                          <v-text-field ref="Email0" label="E-mail *" v-model="itemSelected.Email0" :rules="rules.Email0" :dense="text_filled" :filled="text_filled" />

                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <v-text-field ref="Tel0" label="เบอร์โทรศัพท์ *" v-model="itemSelected.Tel0" :rules="rules.Tel0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="2" class="pr-2">
                                          <v-text-field ref="Ext_number0" label="เบอร์ต่อ" v-model="itemSelected.Ext_number0" :rules="rules.Ext_number0" :dense="text_filled" :filled="text_filled" />
                                        </v-col>
                                    </v-row>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                  <v-expansion-panel-header><strong>ผู้ประสานงานหลักลำดับที่ 1 (ข้อมูลจำเป็น) *</strong></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <!-- content -->
                                    <v-row>
                                                  <!-- no.1 -->
                                        <v-col cols="12" sm="1" class="pr-2">
                                                <v-combobox :items="TitleName_th1" dense filled hide-selected ref="TitleName_th1 *" label="คำนำ *" v-model="itemSelected.TitleName_th1" :rules="rules.TitleName_th1" @input="handleThaiTitleInput1" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="Name_th1" label="ชื่อ *" v-model="itemSelected.Name_th1" :rules="rules.Name_th1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_th1 *" label="นามสกุล *" v-model="itemSelected.LastName_th1" :rules="rules.LastName_th1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_th1" label="ตำแหน่ง *" v-model="itemSelected.Position_th1" :rules="rules.Position_th1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="1" class="pr-2">
                                          <v-combobox :items="TitleName_en1" dense filled hide-selected ref="TitleName_en1" label="Prename *" v-model="itemSelected.TitleName_en1" :rules="rules.TitleName_en1" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="Name_en1" label="Firstname *" v-model="itemSelected.Name_en1" :rules="rules.Name_en1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_en1" label="Lastname *" v-model="itemSelected.LastName_en1" :rules="rules.LastName_en1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_en_1" label="Position *" v-model="itemSelected.Position_en_1" :rules="rules.Position_en_1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <v-text-field ref="Email1" label="E-mail *" v-model="itemSelected.Email1" :rules="rules.Email1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <v-text-field ref="Tel1" label="เบอร์โทรศัพท์ *" v-model="itemSelected.Tel1" :rules="rules.Tel1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="2" class="pr-2">
                                          <v-text-field ref="Ext_number1" label="เบอร์ต่อ" v-model="itemSelected.Ext_number1" :rules="rules.Ext_number1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>
                                    </v-row>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>

                              

                                <v-expansion-panel>
                                  <v-expansion-panel-header><strong>ผู้ประสานงานลำดับที่ 2<font color="#0661F5"> (Click เพื่อเพิ่ม)</font></strong></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <!-- content -->         

                          <!-- No.2 -->
                                      <v-row>
                                        <v-col cols="12" sm="1" class="pr-2">
                                          <v-combobox :items="TitleName_th2" dense filled hide-selected ref="TitleName_th2" label="คำนำ" v-model="itemSelected.TitleName_th2" :rules="rules.TitleName_th2" @input="handleThaiTitleInput2" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="Name_th2" label="ชื่อ" v-model="itemSelected.Name_th2" :rules="rules.Name_th2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_th2" label="นามสกุล" v-model="itemSelected.LastName_th2" :rules="rules.LastName_th2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_th2" label="
                          ตำแหน่ง" v-model="itemSelected.Position_th2" :rules="rules.Position_th2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="1" class="pr-2">
                                          <v-combobox :items="TitleName_en2" dense filled hide-selected ref="TitleName_en2" label="Prename" v-model="itemSelected.TitleName_en2" :rules="rules.TitleName_en2" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="Name_en2" label="Firstname" v-model="itemSelected.Name_en2" :rules="rules.Name_en2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="4" class="pr-2">
                                          <v-text-field ref="LastName_en2" label="Lastname" v-model="itemSelected.LastName_en2" :rules="rules.LastName_en2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="3" class="pr-2">
                                          <v-text-field ref="Position_en_2" label="Position" v-model="itemSelected.Position_en_2" :rules="rules.Position_en_2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <v-text-field ref="Email2" label="E-mail" v-model="itemSelected.Email2" :rules="rules.Email2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="5" class="pr-2">
                                          <v-text-field ref="Tel2" label="เบอร์โทรศัพท์" v-model="itemSelected.Tel2" :rules="rules.Tel1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                        <v-col cols="12" sm="2" class="pr-2">
                                          <v-text-field ref="Ext_number2" label="เบอร์ต่อ" v-model="itemSelected.Ext_number2" :rules="rules.Ext_number2" :dense="text_filled" :filled="text_filled" />
                                        </v-col>

                                      </v-row>
                                    <!-- content -->
                                  </v-expansion-panel-content>
                                </v-expansion-panel>


                                <v-expansion-panel>
                                  <v-expansion-panel-header><strong>ผู้ประสานงานลำดับที่ 3<font color="#0661F5"> (Click เพื่อเพิ่ม)</font></strong></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-row>
                                      <!-- No.3 -->
                                    <v-col cols="12" sm="1" class="pr-2">
                                      <v-combobox :items="TitleName_th3" dense filled hide-selected ref="TitleName_th3" label="คำนำ" v-model="itemSelected.TitleName_th3" :rules="rules.TitleName_th3" @input="handleThaiTitleInput3" />
                                    </v-col>

                                    <v-col cols="12" sm="4" class="pr-2">
                                      <v-text-field ref="Name_th3" label="ชื่อ" v-model="itemSelected.Name_th3" :rules="rules.Name_th3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>

                                    <v-col cols="12" sm="4" class="pr-2">
                                      <v-text-field ref="LastName_th3" label="
                          นามสกุล" v-model="itemSelected.LastName_th3" :rules="rules.LastName_th3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>

                                    <v-col cols="12" sm="3" class="pr-2">
                                      <v-text-field ref="Position_th3" label="ตำแหน่ง" v-model="itemSelected.Position_th3" :rules="rules.Position_th3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>

                                    <v-col cols="12" sm="1" class="pr-2">
                                      <v-combobox :items="TitleName_en3" dense filled hide-selected ref="TitleName_en3" label="Prename" v-model="itemSelected.TitleName_en3" :rules="rules.TitleName_en3" />
                                    </v-col>

                                    <v-col cols="12" sm="4" class="pr-2">
                                      <v-text-field ref="Name_en3" label="Firstname" v-model="itemSelected.Name_en3" :rules="rules.Name_en3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>

                                    <v-col cols="12" sm="4" class="pr-2">
                                      <v-text-field ref="LastName_en3" label="Lastname" v-model="itemSelected.LastName_en3" :rules="rules.LastName_en3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>

                                    <v-col cols="12" sm="3" class="pr-2">
                                      <v-text-field ref="Position_en_3" label="Position" v-model="itemSelected.Position_en_3" :rules="rules.Position_en_3" :dense="text_filled" :filled="text_filled" />
                                    </v-col>
                                        <v-col cols="12" sm="5">
                                          <v-text-field ref="Email3" label="E-mail" v-model="itemSelected.Email3" :rules="rules.Email3" :dense="text_filled" :filled="text_filled" />
                                        </v-col>
                                        <v-col cols="12" sm="5">
                                          <v-text-field ref="Tel3" label="เบอร์โทรศัพท์" v-model="itemSelected.Tel3" :rules="rules.Tel1" :dense="text_filled" :filled="text_filled" />
                                        </v-col>
                                        <v-col cols="12" sm="2">
                                          <v-text-field ref="Ext_number3" label="เบอร์ต่อ" v-model="itemSelected.Ext_number3" :rules="rules.Ext_number3" :dense="text_filled" :filled="text_filled" />
                                        </v-col>
                                      </v-row>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                      </div>
                    </v-col>  
                  </v-form>
              </v-card>

              <!-- stepp 4 (quiz) -->
              <v-card  class="mb-12" height="100%" elevation="0" style="margin-top: -40px;">
                <v-form v-if="curr===4" :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height class="elevation-0">

                  <v-row no-gutters >

                    <v-col cols="12" sm="12" hidden>
                      <v-row no-gutters>
                        <v-col cols="12" sm="6" class="pr-2">
                          <v-text-field counter="20" :dense="text_filled" :filled="text_filled"
                            label="_MemberCode_"
                            v-model="itemSelected.MemberCode"
                            :rules="rules.MemberCode"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" class="pr-2" hidden>
                      <v-text-field ref="TradeCode" counter="20" label="_TradeCode_" v-model="itemSelected.TradeCode" :rules="rules.TradeCode" :dense="text_filled" :filled="text_filled" />
                    </v-col>

                    <v-col cols="12" sm="6" class="pr-2" hidden>
                      <v-text-field ref="Id" counter="100" label="_Id_" v-model="itemSelected.Id" :rules="rules.Id" :dense="text_filled" :filled="text_filled" />
                    </v-col>
                    <v-col cols="12" sm="12" class="pr-2">
                      <v-row>
                            <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">สัดส่วนผู้ถือหุ้น</span></div>
                            </v-col>
                            
                            <v-col cols="12" sm="3" class="pr-2">
                              <v-text-field suffix="%"  ref="Share_thai" label="สัดส่วนผู้ถือหุ้น(ไทย) *" v-model="itemSelected.Share_thai" :rules="rules.Share_thai" :dense="text_filled" :filled="text_filled" />
                            </v-col>

                            <v-col cols="12" sm="3" class="pr-2">
                              <v-text-field suffix="%"  ref="Share_foreign" label="สัดส่วนผู้ถือหุ้น(ต่างชาติ) *" v-model="itemSelected.Share_foreign" :rules="rules.Share_foreign" :dense="text_filled" :filled="text_filled" />
                            </v-col>

                            <v-col cols="12" sm="3" class="pr-2">
                              <v-text-field  ref="Nationshare" label="สัญชาติของผู้ถือหุ้นใหญ่ *" v-model="itemSelected.Nationshare" :rules="rules.Nationshare" :dense="text_filled" :filled="text_filled" />
                            </v-col>

                            <v-col cols="12" sm="3" class="pr-2">
                              <v-text-field ref="Original_com" label="ระบุชื่อบริษัทต้นสังกัด *" v-model="itemSelected.Original_com" :rules="rules.Original_com" :dense="text_filled" :filled="text_filled" />
                            </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" class="pr-2">
                      <v-row>
                                <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">ประเภทอุตสาหกรรม</span></div>
                            </v-col>
                            <!-- PersonInput -->
                            <v-col cols="12" sm="3" class="pr-2">
                              <v-autocomplete
                                    ref="Business_Title"                         
                                    v-model="Business_Title"                       
                                    :multiple="true"
                                    :small-chips="true"
                                    :deletable-chips="true"
                                    :auto-select-first="true"
                                    :dense="true" 
                                    :filled="true"                
                                    :items="BusinessTitles"
                                    item-text="EmpName"
                                    item-value="EmpName" 
                                    label="อุตสาหกรรมหลัก *"
                                    hint="เลือกได้มากกว่า 1 ข้อ"
                                    :clearable="true"
                                    :rules="rules.Business_Title"
                                  >
                                  </v-autocomplete>
                            </v-col>

                              <v-col cols="12" sm="3" class="pr-2">
                                <v-autocomplete
                                      ref="Tier_Title"
                                      v-model="Tier_Title"
                                      :multiple="true"
                                      :small-chips="true"
                                      :deletable-chips="true"
                                      :auto-select-first="true"
                                      :dense="true" 
                                      :filled="true"                
                                      :items="TierTitles"
                                      item-text="EmpName"
                                      item-value="EmpName" 
                                      label="กรุณาเลือก *"
                                      hint="เลือกได้มากกว่า 1 ข้อ"
                                      :clearable="true"
                                      :rules="rules.Tier_Title"
                              >
                                </v-autocomplete>                     
                              </v-col>

                              <v-col cols="12" sm="3" class="pr-2">
                                <v-autocomplete
                                    ref="Related_industry"
                                    v-model="Related_industry"
                                    :multiple="true"
                                    :small-chips="true"
                                    :deletable-chips="true"
                                    :auto-select-first="true"
                                    :dense="true" 
                                    :filled="true"                
                                    :items="Relatedindustrys"
                                    item-text="EmpName"
                                    item-value="EmpName" 
                                    label="อุตสาหกรรมเกี่ยวเนื่อง *"
                                    hint="เลือกได้มากกว่า 1 ข้อ"
                                    :clearable="true"
                                    :rules="rules.Related_industry"
                              >
                                </v-autocomplete>                     
                            </v-col>

                              <v-col cols="12" sm="3" class="pr-2">
                                <v-text-field ref="Related_other" label="อุตสาหกรรมเกี่ยวเนื่องอื่นๆ (โปรดระบุ)" v-model="itemSelected.Related_other" :rules="rules.Related_other" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="4" class="pr-2" hidden>
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">3.กระบวนการผลิต</span></div>
                              </v-col>
                            
                              <v-col cols="12" sm="6" class="pr-2">
                                  <v-select v-model="itemSelected.Process" ref="Process" :items="Process" :rules="rules.Process" :dense="text_filled" :filled="text_filled" :menu-props="{ maxHeight: '400' }" label="กระบวนการผลิต" multiple hint="เลือกได้มากกว่า 1 ข้อ" persistent-hint />          
                          </v-col>
                              <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field ref="Process_other" label="อื่นๆ (โปรดระบุ)" v-model="itemSelected.Process_other" :rules="rules.Process_other" :dense="text_filled" :filled="text_filled" />
                              </v-col>

                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="4" class="pr-2" hidden>
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">4.ผลิตภัณฑ์ </span></div>
                              </v-col>
                            
                              <v-col cols="12" sm="6" class="pr-2">
                                <v-select v-model="itemSelected.Product_type" ref="Product_type" :items="Product_type" :rules="rules.Product_type" :dense="text_filled" :filled="text_filled" :menu-props="{ maxHeight: '400' }" label="ประเภทผลิตภัณฑ์" multiple hint="เลือกได้มากกว่า 1 ข้อ" persistent-hint  />
                              </v-col>
                              <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field ref="Product_type_other" label="อื่นๆ (โปรดระบุ)" v-model="itemSelected.Product_type_other" :rules="rules.Product_type_other" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                      </v-row>
                    </v-col>


                    <v-col cols="12" sm="4" class="pr-2" hidden>
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">5.ระบบคุณภาพ</span></div>
                              </v-col>                  
                              <v-col cols="12" sm="6" class="pr-2">
                                <v-select v-model="itemSelected.Quality_system" ref="Quality_system" :items="Quality_system" :rules="rules.Quality_system" :dense="text_filled" :filled="text_filled" :menu-props="{ maxHeight: '400' }" label="ระบบการรับรองคุณภาพ" multiple hint="เลือกได้มากกว่า 1 ข้อ" persistent-hint  />
                              </v-col>
                              <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field ref="Quality_system_other" label="อื่นๆ (โปรดระบุ)" v-model="itemSelected.Quality_system_other" :rules="rules.Quality_system_other" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                      </v-row>
                    </v-col>


                    <v-col cols="12" sm="12" class="pr-2" hidden>
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">6.ผลิตภัณฑ์หลักและกำลังการผลิต</span></div>
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="Main_product1" label="ผลิตภัณฑ์หลัก" v-model="itemSelected.Main_product1" :rules="rules.Main_product1" :dense="text_filled" :filled="text_filled"  persistent-hint prefix="1."/>
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="item1" label="กำลังการผลิต" v-model="itemSelected.item1" :rules="rules.item1" :dense="text_filled" :filled="text_filled" hint="ชิ้น/ปี" />
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="Main_product2" label="ผลิตภัณฑ์หลัก" v-model="itemSelected.Main_product2" :rules="rules.Main_product2" :dense="text_filled" :filled="text_filled" prefix="2."/>
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="item2" label="กำลังการผลิต" v-model="itemSelected.item2" :rules="rules.item2" :dense="text_filled" :filled="text_filled" hint="ชิ้น/ปี" />
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="Main_product3" label="ผลิตภัณฑ์หลัก" v-model="itemSelected.Main_product3" :rules="rules.Main_product3" :dense="text_filled" :filled="text_filled" prefix="3."/>
                              </v-col>
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="item3" label="กำลังการผลิต" v-model="itemSelected.item3" :rules="rules.item3" :dense="text_filled" :filled="text_filled" hint="ชิ้น/ปี" />
                              </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="12" class="pr-2" hidden>
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">7.ตลาดและลูกค้า</span></div>
                              </v-col>
                            
                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field suffix="%" ref="Domestic" label="ตลาดภายในประเทศ" v-model="itemSelected.Domestic" :rules="rules.Domestic" :dense="text_filled" :filled="text_filled" />
                              </v-col>

                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field suffix="%" ref="Export" label="ตลาดส่งออก" v-model="itemSelected.Export" :rules="rules.Export" :dense="text_filled" :filled="text_filled" />
                              </v-col>

                              <v-col cols="12" sm="2" class="pr-2">
                                <v-text-field ref="Export_country" label="(ระบุประเทศส่งออก)" v-model="itemSelected.Export_country" :rules="rules.Export_country" :dense="text_filled" :filled="text_filled" />
                              </v-col>

                              <v-col cols="12" sm="3" class="pr-2">
                                <v-text-field ref="Main_domestic" label="ลูกค้าหลักในประเทศ (โปรดระบุ)" v-model="itemSelected.Main_domestic" :rules="rules.Main_domestic" :dense="text_filled" :filled="text_filled" />
                              </v-col>

                              <v-col cols="12" sm="3" class="pr-2">
                                <v-text-field ref="Main_foreign" label="ลูกค้าหลักนอกประเทศ (โปรดระบุ)" v-model="itemSelected.Main_foreign" :rules="rules.Main_foreign" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                      </v-row>
                    </v-col>


                    <v-col cols="12" sm="6" class="pr-2">
                      <v-row>
                          <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">ขนาดของกิจการ</span></div>
                          </v-col>                
                          
                          <v-col cols="12" sm="4" class="pr-2">
                                <v-text-field ref="Staff" label="จำนวนบุคลากรทั้งหมด *" v-model="itemSelected.Staff" :rules="rules.Staff" :dense="text_filled" :filled="text_filled" @input="formatInput"/>
                          </v-col>

                          <v-col cols="12" sm="4" class="pr-2">
                                <v-text-field :suffix="currency" ref="Register_capital" label="ทุนจดทะเบียน *" v-model="itemSelected.Register_capital" :rules="rules.Register_capital" :dense="text_filled" :filled="text_filled" @input="formatInput" />
                          </v-col>
                          <v-col cols="12" sm="4" class="pr-2">
                                <v-text-field :suffix="currency" ref="Paid_capital" label="ทุนชำระแล้ว *" v-model="itemSelected.Paid_capital" :rules="rules.Paid_capital" :dense="text_filled" :filled="text_filled" @input="formatInput" />
                          </v-col>
                              <!-- **Strat Comma  -->
                              <!-- <v-col cols="12" sm="4" class="pr-2">
                                <v-text-field :prefix="currency" ref="Register_capital" label="ทุนจดทะเบียน(ล้านบาท)" v-model="initialBalanceFormatted" :rules="rules.Register_capital" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                              <v-col cols="12" sm="4" class="pr-2">
                                <v-text-field :prefix="currency" ref="Paid_capital" label="ทุนชำระแล้ว(ล้านบาท)" v-model="initialPaidFormatted" :rules="rules.Paid_capital" :dense="text_filled" :filled="text_filled" />
                              </v-col> -->
                              <!-- End Comma -->
                        </v-row>
                    </v-col> 

                    <v-col cols="12" sm="6" class="pr-2">
                      <v-row>
                              <v-col cols="12" sm="12" class="pr-2"><div class="light-blue darken-1 text-left" style="margin-bottom: -26px;"><span class="white--text" style="margin-left: 5px;">กิจกรรมของสถาบันยานยนต์ที่ท่านสนใจ</span></div>
                              </v-col>

                              <v-col cols="12" sm="6" class="pr-2">
                                <v-autocomplete
                                    ref="Tai_activity"
                                    v-model="Tai_activity"
                                    :multiple="true"
                                    :small-chips="true"
                                    :deletable-chips="true"
                                    :auto-select-first="true"
                                    :dense="true" 
                                    :filled="true"                
                                    :items="Taiactivitys"
                                    item-text="EmpName"
                                    item-value="EmpName" 
                                    :menu-props="{ maxHeight: '400' }"
                                    label="กรุณาเลือก *"
                                    hint="เลือกได้มากกว่า 1 ข้อ"
                                    :clearable="true"
                                    :rules="rules.Tai_activity"
                              >
                                </v-autocomplete>                     
                              </v-col>

                              <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field ref="Tai_activity_other" label="อื่นๆ (โปรดระบุ)" v-model="itemSelected.Tai_activity_other" :rules="rules.Tai_activity_other" :dense="text_filled" :filled="text_filled" />
                              </v-col>
                      </v-row>
                    </v-col>   
                  </v-row>
                </v-form>
              </v-card>
    
              <!-- stepp 5 (attach) -->
              <v-card  class="mb-12" height="100%" elevation="0" style="margin-top: -40px;">
                <v-form v-if="curr===5" :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height class="elevation-0">

                  <!-- <v-row no-gutters> -->
                        <v-col cols="12" sm="12" hidden>
                          <v-row no-gutters>
                            <v-col cols="12" sm="6" class="pr-2">
                              <v-text-field counter="20" :dense="text_filled" :filled="text_filled"
                                label="_MemberCode_"
                                v-model="itemSelected.MemberCode"
                                :rules="rules.MemberCode"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12"  class="pr-2">
                          เอกสารประกอบการพิจารณา (แนบพร้อมใบสมัคร) และรับรองสำเนาถูกต้อง โดยผู้มีอำนาจลงนาม (Please upload the following for this application:)<br>
                          กรุณาตั้งชื่อไฟล์ทีทำการอัพโหลด โดยใส่หมายเลขกำกับดังตารางข้างล่างนี้
                        </v-col>
                  <!-- </v-row>  -->
                            <v-divider></v-divider>

                                  <!--Start term -->
                                  <!-- <v-row justify="center"> -->
                                      <v-col cols="12" sm="12" class="pr-2" >
                                        <v-data-table
                                        :headers="headers"
                                        :items="attatchments"
                                        :items-per-page="5"
                                        :hide-default-footer="true"
                                        class="elevation-1"
                                      ></v-data-table>
                                      </v-col>
                                  <!-- </v-row> -->
                                  <v-row justify="center" style="margin-top: -20px;">
                                      <v-col cols="12" sm="8" class="pr-2" >
                                          <!-- <v-checkbox ref="agree" label=" I agree to these" v-model="itemSelected.agree" :rules="rules.agree"   /> -->
                                          <!-- <attach
                                          :itemSelected="itemSelected"
                                          >                            
                                          </attach> -->

                                          <dropzone-v2 
                                            dzName="PRFile01" 
                                            ref="PRFile01" 
                                            :nameCode="'*'" 
                                            :appName="'member'"
                                            :code="itemSelected.MemberCode" :list="''" 
                                            :fileType="'application/pdf'" :maxSize="2"
                                            :canDelete="true" :canUpload="true">
                                          </dropzone-v2>

                                      </v-col>                                
                                  </v-row>
                                  <h3 style="text-align:center;margin-top: -10px;">ตรวจสอบข้อมูลการสมัครสมาชิกสถาบันยานยนต์ <br>
                                    <v-btn @click="previewShow(itemSelected)" color="blue-grey">Preview PDF</v-btn>
                                  </h3>
                                  

                            <v-row justify="center">
                                <v-col cols="12" sm="4" class="pr-2" style="margin-top: 10px;">
                                    <v-checkbox label=" ได้ส่งเอกสารประกอบการสมัคร และขอยืนยันข้อมูลถูกต้อง " v-model="accepted" :rules="rules.accepted"   />                                    
                                  
                                </v-col>
                            </v-row>
                            <!-- <v-checkbox ref="accepted" label=" ยอมรับ " v-model="accepted" :rules="rules.agree"   /> -->

                                  <!-- <v-row justify="center" style="margin-top: -20px;">
                                      <v-col cols="12" sm="4" class="pr-2" >
                                        <h3>ตรวจสอบข้อมูลการสมัครสมาชิกสถาบันยานยนต์</h3>
                                        <v-btn @click="previewShow(itemSelected)" color="blue-grey">Preview PDF</v-btn>
                                      </v-col>
                                  </v-row> -->
                </v-form>
              </v-card>
              
              <!-- stepp 6 (Complete) -->
              <v-card  class="mb-12" height="100%" elevation="0" style="margin-top: -40px;">
                        <v-form v-if="curr===6" :ref="'stepForm'" v-model="step.valid" lazy-validation fluid fill-height class="elevation-0">
                            <v-row no-gutters>
                              <v-col cols="12" sm="6"  class="pr-2" style="margin-left: 270px;">
                                  ขอขอบพระคุณเป็นอย่างสูง<br><br>
                                  สถาบันยานยนต์ได้รับข้อมูลการสมัครสมาชิกฯ ของท่านเป็นที่เรียบร้อยแล้ว<br>
                                  โดยเจ้าหน้าที่จะทำการตรวจสอบข้อมูลและออก “จดหมายรับรองการเป็นสมาชิก” ให้หน่วยงานของท่านต่อไป<br><br>

                                  สอบถามรายละเอียดเพิ่มเติม <br>
                                  แผนกการตลาดและลูกค้าสัมพันธ์ สถาบันยานยนต์<br>
                                  โทรศัพท์: 02-712-2414 ต่อ 6301-6303<br>
                                  อีเมล: <a href="mailto: marketing@thaiauto.or.th">marketing@thaiauto.or.th</a><br>
                                  ไลน์: <a href="http://line.me/ti/p/@thaiauto" target="_blank">@thaiauto</a>
                                </v-col>
                                <v-col cols="12" sm="6"  class="pr-2">
                                  <v-btn  color="success" href="https://www.thaiauto.or.th/2020/th/member/" target="_blank" style="margin-left: 270px;" >การสมัครสมาขิกสำเร็จแล้ว </v-btn><!-- กลับหน้า website -->
                                  <!-- <v-btn  color="success" href="https://www.thaiauto.or.th/2020/th/member/" target="_blank" style="margin-left: 270px;" @click="AppvMessage">การสมัครสมาขิกสำเร็จแล้ว กรุณา Click เพื่อ Email และกลับเข้าสู่หน้าเว็บไซต์</v-btn>กลับหน้า website -->

                                        <!-- PDF button -->
                                        <!-- <v-btn @click="previewShow(itemSelected)">Preview PDF</v-btn> -->
                                </v-col>
                            </v-row>
                        </v-form>
              </v-card>


              <!-- Button Stepper -->
              <v-row no-gutters class="justify-end">            
                <!-- <v-btn  v-else color="success" @click="done()" href="https://www.thaiauto.or.th/2020/th/" target="_self" style="margin-left: 270px;">การสมัครสมาขิกสำเร็จแล้ว Click เพื่อยืนยัน</v-btn>กลับหน้า website -->
                <v-btn  v-if="curr > 1 && curr !== lastStep" text @click="curr = n">ย้อนกลับ</v-btn>
                <!-- old -->
                <v-btn                  
                  v-if="n + 1 < lastStep"
                  color="primary"
                  @click="validate(curr)"
                  :disabled="!step.valid"
                  >ต่อไป</v-btn
                >
                <!-- when curr===5 send mail -->
                <!-- <v-btn                  
                  v-if="n + 1 < lastStep"
                  color="primary"
                  @click="curr === 5 ? (AppvMessage(), validate(curr)) : validate(curr)"
                  :disabled="!step.valid"
                  >ต่อไป</v-btn
                > -->
              </v-row>          

        </v-stepper-content>
      </v-stepper>
    </v-container>
    <pdf ref="pdfItem" :title="'<v-icon dark>print</v-icon>'"></pdf>
  </div>
</template>

<script>
import itemService from '@/store/api/services/taimemberService'
import attach from "@/components/taimember/attachEdit";
import term from "@/components/taimember/termEdit";
import pdf from "@/components/taimember/previewPDF";
import userService from "@/store/api/services/users";
import otp from '@/otp';

export default {
  name: 'memberallEdit',
  components: {
    attach,
    term,
    pdf,
    userService,
    otp,
    // VueSignaturePad,
    // Itisopdf
  },
  props: {
    dialogClose: {
      type: Boolean
    },
    itemSelected: {
      type: Object,
      default: function() {
        return {
// เริ่มข้อมูลตัวอย่าง
          // Register_capital:0, 
          // Paid_capital:0,
          // TradeCode:'1111111111111',
          // Member_Type: "นิติบุคคล/Juristic Persons",
          // Member_Title: "ห้างหุ้นส่วน",
          // Name_Com_th: "สถาบันยานยนต์",
          // Name_Com_en: "Thailand Automotive Institute",
          // AddressNumber_th : "123",
          // Moo_th : "15",
          // Building_th : "สำนักพัฒนาอุตสาหกรรมรายสาขา",
          // Floor : "4",
          // Soi_th : "ตรีมิตร กล้วยน้ำไท",
          // Road_th : "กล้วยน้ำไท",
          // Tambon_th : "คลองเตย",
          // Amphur_th: "คลองเตย",
          // Province_th: " กรุงเทพฯ",
          // Zipcode: "10110",
          // Industrial_estate_th: "การพิมพ์และบรรจุภัณฑ์สินสาคร",
          // AddressNumber_en: "123",
          // Moo_en: "15",
          // Building_en: " Bureau of Industrial Sectors ",
          // Floor: "4",
          // Soi_en: "Trimitr Kluaynamthai",
          // Road_en: "Rama IV",
          // Tambon_en: " Klongtoey",
          // Amphur_en: " Klongtoey",
          // Province_en: "Bangkok",
          // Zipcode1: "10110",
          // Industrial_estate_en: "Sinsakhon Printing City",
          // Tel: "66-2712-2414",
          // Ext: "6602",
          // Email: "tequila.vodka@gmail.com",
          // Website: "https://www.thaiauto.or.th/",
          // TitleName_th0: "นาย",
          // Name_th0: "กกกกกก",
          // LastName_th0: "กกกกกก",
          // Position_th0: "กกกกกก",
          // TitleName_en0: "AAAAA",
          // Name_en0: "AAAAA",
          // LastName_en0: "AAAAA",
          // Position_en0: "AAAAA",
          // Email0 : "AAA@thaiauto.or.th",
          // Tel0: "11111111",
          // Ext_number0: "6601",
          // TitleName_th1: "นางสาว",
          // Name_th1: "ขขขขขข",
          // LastName_th1: "ขขขขขข",
          // Position_th1: "ขขขขขข",
          // TitleName_en1: "BBBBB",
          // Name_en1: "BBBBB",
          // LastName_en1: "BBBBB",
          // Position_en_1: "BBBBB",
          // Email1 : "BBBBB@thaiauto.or.th",
          // Tel1: "22222222",
          // Ext_number1: "6602",
          // TitleName_th2: "คคคคคค",
          // Name_th2: "คคคคคค",
          // LastName_th2: "คคคคคค",
          // Position_th2: "คคคคคค",
          // TitleName_en2: "CCCC",
          // Name_en2: "CCCCCC",
          // LastName_en2: "CCCCCC",
          // Position_en_2: "CCCCCC",
          // Email2: "CCC@thaiauto.or.th",
          // Tel2: "333333333",
          // Ext_number2: "6603",
          // TitleName_th3: "งงงงงงง",
          // Name_th3: "งงงงงงง",
          // LastName_th3: "งงงงงงง",
          // Position_th3: "งงงงงงง",
          // TitleName_en3: "DDDDD",
          // Name_en3: "DDDDD",
          // LastName_en3: "DDDDD",
          // Position_en_3: "DDDDD",
          // Email3: "DDD@thaiauto.or.th",
          // Tel3: "44444444",
          // Ext_number3: "6604",
          // Share_thai: "12",
          // Share_foreign: "58",
          // Nationshare: "อินเดีย",
          // Original_com: "กระทรวงอุตสาหกรรม",
          // Related_other: "333",
          // Register_capital: 10,
          // Paid_capital: 20,
          // Staff: "250",
          // Tai_activity_other: "333",
// จบข้อมูล
        }
      }
    },
    action: {
      type: String,
      default: function() {
        return 'add'
      }
    },
  },
  data() {
    return {
      pathStatic: process.env.VUE_APP_STATIC,
      errorMessages: [],
      lazy: false,
      debug: false,
      formValid: true,
      loading: true,
      text_filled: true,
      oldItem: {},
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no',
        },
        { text: 'รายการ', value: 'list', sortable: false },
        { text: 'ขนาดไฟล์', value: 'size', sortable: false },
      
      ],
      attatchments: [
        {
          no: '1.',
          list: 'สำเนาหนังสือรับรองการจดทะเบียนกระทรวงพาณิชย์ (จำเป็น) *',
          size: 'ขนาดไฟล์ไม่เกิน 2 mb',
          color: 'red'
        },
        {
          no: '2.',
          list: 'สำเนา ภ.พ. 20 หรือ ภ.พ.01 , 09 (จำเป็น) *',
          size: 'ขนาดไฟล์ไม่เกิน 2 mb',
        },
        // {
        //   no: '3.',
        //   list: 'สำเนาใบอนุญาตประกอบกิจการโรงงาน (ถ้ามี)',
        //   size: 'ขนาดไฟล์ไม่เกิน 2 mb',
        // },
        // {
        //   no: '4.',
        //   list: 'แผนที่โรงงาน/สำนักงาน',
        //   size: 'ขนาดไฟล์ไม่เกิน 2 mb',
        // },
        {
          no: '3.',
          list: 'Company Profile (ถ้ามี)',
          size: 'ขนาดไฟล์ไม่เกิน 2 mb',
        },
      ],


      // PersonInput Component
      pdfdata:{},
        pError:false,
        mProp:{
          maxHeight: 250,
        },
        // person: '',
        // Member_Title: [],
        // e_input:'',
        BusinessOption: [
          { EmpCode: '0001', EmpName: 'ผู้ประกอบรถยนต์' },
          { EmpCode: '0002', EmpName: 'ผู้ผลิตชิ้นส่วนรถยนต์' },
          { EmpCode: '0003', EmpName: 'ผู้ผลิตชิ้นส่วนอะไหล่ทดแทน(REM)'},
          { EmpCode: '0004', EmpName: 'ผู้ประกอบรถจักรยานยนต์' },
          { EmpCode: '0005', EmpName: 'ผู้ผลิตชิ้นส่วนรถจักรยานยนต์'},
        ],
        TierTitleOption: [
          { EmpCode: '1001', EmpName: '1st Tier' },
          { EmpCode: '1002', EmpName: '2nd Tier' },
          { EmpCode: '1003', EmpName: '3rd Tier'},
        ],
        RelatedindustryOption: [
          { EmpCode: '2001', EmpName: 'เหล็ก' },
          { EmpCode: '2002', EmpName: 'พลาสติก' },
          { EmpCode: '2003', EmpName: 'ยาง'},
          { EmpCode: '2004', EmpName: 'อิเล็กทรอนิกส์' },
          { EmpCode: '2005', EmpName: 'แก้วและกระจก'},          
          { EmpCode: '2006', EmpName: 'ผ้าและเครื่องหนัง'},          
          { EmpCode: '2007', EmpName: 'เครื่องจักรกล เครื่องมือ'},          
          { EmpCode: '2008', EmpName: 'แม่พิมพ์'},          
          { EmpCode: '2009', EmpName: 'อุปกรณ์จับยึดชิ้นงาน'},          
          { EmpCode: '2010', EmpName: 'อื่นๆ'},        
        ],
        TaiactivityOption: [
          { EmpCode: '3001', EmpName: 'ทดสอบผลิตภัณฑ์' },
          { EmpCode: '3002', EmpName: 'พัฒนาผลิตภัณฑ์' },
          { EmpCode: '3003', EmpName: 'พัฒนาบุคลากร'},
          { EmpCode: '3004', EmpName: 'พัฒนากระบวนการผลิตเพื่อเพิ่มผลิตภาพ' },
          { EmpCode: '3005', EmpName: 'ข้อมูลด้านวิเคราะห์ธุรกิจที่เกี่ยวข้องกับอุตสาหกรรมยานยนต์และชิ้นส่วน'},
          { EmpCode: '3006', EmpName: 'อื่นๆ'},          
      ],
      // End PersonInput Component
      currency: "ล้านบาท",
      initialBalance: null,
      initialPaid: null,
      pomtest:{pp:null},
      text_filled: false, // Define if the field should appear filled
      curr: 1,
      
      lastStep: 6,
      steps: [
        { name: "ส่วนที่ 1 - ข้อมูลทั่วไป", rules: [(v) => !!v || "Required."], valid: true },
        { name: "ส่วนที่ 2 - ที่อยู่", rules: [(v) => !!v || "Required."], valid: true },
        { name: "ส่วนที่ 3 - ติดต่อประสานงาน", rules: [(v) => !!v || "Required."], valid: true },
        { name: "ส่วนที่ 4 - ข้อมูลบริษัท", rules: [(v) => !!v || "Required."], valid: true },
        { name: "ส่วนที่ 5 - แนบเอกสาร", rules: [(v) => !!v || "Required."], valid: true },
        // {
        //   name: "ส่วนที่ 3 - ติดต่อประสานงาน",
        //   rules: [(v) => (v && v.length >= 4) || "Enter at least 4 characters."],
        //   valid: true,
        // },
        // {
        //   name: "ส่วนที่ 4 - ข้อมูลบริษัท",
        //   rules: [(v) => (v && v.length >= 4) || "Enter at least 4 characters."],
        //   valid: true,
        // },
        // {
        //   name: "ส่วนที่ 5 - แนบเอกสาร",
        //   rules: [(v) => (v && v.length >= 4) || "Enter at least 5 characters."],
        //   valid: true,
        // },
        { name: "ส่วนที่ 6 - สำเร็จ" },//Complete
      ],
      valid: false,
      stepForm: [],
      valid: false,

      // Name_th: "",
        // Name_th: [
        //   (v) => !!v || "website is required",
        //   (v) =>
        //     (v && v.length <= 10) || "website must be less than 10 characters",
        // ],

        // name: "",
        // nameRules: [
        //   (v) => !!v || "Name is required",
        //   (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
        // ],
        // EmailRules: [
        //   (v) => !!v || "E-mail is required",
        //   (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        // ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
        // endtest
        e1: 1,
        Member_Type: ["นิติบุคคล/Juristic Persons"],
        Member_Title: ["บริษัท", "ห้างหุ้นส่วน"],
        //   { EmpCode: '2', EmpName: 'ห้างหุ้นส่วน' },],
        pathStatic: process.env.VUE_APP_STATIC,
        errorMessages: [],
        lazy: false,
        debug: false,
        formValid: false,
        loading: true,
        text_filled: true,
        oldItem: {},
        // Step 3
        panel: [0, 1],
        disabled: false,
        readonly: false,
        TitleName_th0: ['นาย', 'นาง', 'นส.'],
        TitleName_th1: ['นาย', 'นาง', 'นส.'],
        TitleName_th2: ['นาย', 'นาง', 'นส.'],
        TitleName_th3: ['นาย', 'นาง', 'นส.'],
        TitleName_en0: ['Mr.', 'Mrs.', 'Miss'],
        TitleName_en1: ['Mr.', 'Mrs.', 'Miss'],
        TitleName_en2: ['Mr.', 'Mrs.', 'Miss'],
        TitleName_en3: ['Mr.', 'Mrs.', 'Miss'],
        // Step 4
        // Business_Title: ['ผู้ประกอบรถยนต์', 'ผู้ผลิตชิ้นส่วนรถยนต์', 'ผู้ผลิตชิ้นส่วนอะไหล่ทดแทน(REM)', 'ผู้ประกอบรถจักรยานยนต์', 'ผู้ผลิตชิ้นส่วนรถจักรยานยนต์'],
        Business_Title: [],
        // Tier_Title: ['1st Tier', '2nd Tier', '3rd Tier'],
        Tier_Title: [],
        // Related_industry: ['เหล็ก', 'พลาสติก', 'ยาง', 'อิเล็กทรอนิกส์', 'แก้วและกระจก', 'ผ้าและเครื่องหนัง', 'เครื่องจักรกล เครื่องมือ', 'แม่พิมพ์', 'อุปกรณ์จับยึดชิ้นงาน', 'อื่นๆ'],
        Related_industry: [],
        Process: ['Casting', 'Forging', 'Plastic Parts', 'Rubber Parts', 'Machining', 'Heat Treatment', 'Surface Treatment', 'Spraying-Painting', 'Welding', 'Trim', 'อื่นๆ'],
        Product_type: ['Accessories', 'Engine', 'Suspension& Brake', 'Body', 'Exterior', 'Electronic', 'Interior', 'Drive, Transmission&Steering','EV', 'Battery', 'Software', 'อื่นๆ'],
        Quality_system: ['ISO/TS16949', 'ISO/TS17025', 'ISO9001', 'ISO14001', 'OHSAS 18001 (TIS 18001)', 'อื่นๆ'],
        // Tai_activity: ['การทดสอบผลิตภัณฑ์', 'การพัฒนาผลิตภัณฑ์', 'การพัฒนาบุคลากร', 'การพัฒนากระบวนการผลิต', 'เพื่อเพิ่มผลิตภาพ', 'ข้อมูลด้านวิเคราะห์ธุรกิจ ที่เกี่ยวข้องกับอุตสาหกรรมยานยนต์และชิ้นส่วนยานยนต์', 'อื่นๆ'],
        Tai_activity: [],
        // Step 5
        agree: false,
        accepted: false,
        dialog: false,
        justify: [
        'center',
        ],
        rules: {
          MemberCode: [],
          TradeCode: [
            (val) => (val && val.length == 13) || "ต้องมี 13 หลัก",
            val => (!val.trim() || !isNaN((val)) ) || 'ต้องเป็นตัวเลข',
            (val) => !!val || "This field is required",
          ], // เลขที่กระทรวงพาณิชย์
          Member_Type: [(val) => !!val || "This field is required"],
          Member_Title: [(val) => !!val || "This field is required"],
          Name_Com_th: [(val) => !!val || "This field is required"],
          Name_Com_en: [(val) => !!val || "This field is required"],
          Name_th: [],
          Lastname_th: [],
          Name_en: [],
          Lastname_en: [],
          AddressNumber_th: [(val) => !!val || "This field is required"],
          Moo_th: [],
          Building_th: [],
          Floor: [],
          Soi_th: [],
          Road_th: [],
          Tambon_th: [(val) => !!val || "This field is required"],
          Amphur_th: [(val) => !!val || "This field is required"],
          Province_th: [(val) => !!val || "This field is required"],
          Zipcode: [(val) => (val && val.length == 5) || "This field is required"],
          Industrial_estate_th: [],
          AddressNumber_en: [(val) => !!val || "This field is required"],
          Moo_en: [],
          Building_en: [],
          Floor1: [],
          Soi_en: [],
          Road_en: [],
          Tambon_en: [(val) => !!val || "This field is required"],
          Amphur_en: [(val) => !!val || "This field is required"],
          Province_en: [(val) => !!val || "This field is required"],
          Zipcode1: [(val) => (val && val.length == 5) || "This field is required"],
          Industrial_estate_en: [],
          Website: [],
          Email: [
            (val) => {
              // email check
              const patternEmail =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return patternEmail.test(val) || "Invalid e-mail.";
            },
            (val) => !!val || "This field is required",
          ],
          Tel: [(val) => !!val || "This field is required"],
          Ext: [],
          InsertDate: [],
          ModifyDate: [],
          ModifyCode: [],
            // Step3
          Contact_type: [],
          TitleName_th0: [(val) => !!val || "This field is required"],
          Name_th0: [(val) => !!val || "This field is required"],
          LastName_th0: [(val) => !!val || "This field is required"],
          Position_th0: [(val) => !!val || "This field is required"],
          TitleName_en0: [(val) => !!val || "This field is required"],
          Name_en0: [(val) => !!val || "This field is required"],
          LastName_en0: [(val) => !!val || "This field is required"],
          Position_en0: [(val) => !!val || "This field is required"],
          Email0: [
            (val) => {
              // email check
              const patternEmail =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return patternEmail.test(val) || "Invalid e-mail.";
            },
            (val) => !!val || "This field is required",
          ],
          Tel0: [],
          Ext_number0: [],
          TitleName_th1: [(val) => !!val || "This field is required"],
          Name_th1: [(val) => !!val || "This field is required"],
          LastName_th1: [(val) => !!val || "This field is required"],
          Position_th1: [(val) => !!val || "This field is required"],
          TitleName_en1: [(val) => !!val || "This field is required"],
          Name_en1: [(val) => !!val || "This field is required"],
          LastName_en1: [(val) => !!val || "This field is required"],
          Position_en_1: [(val) => !!val || "This field is required"],
          Email1: [
            (val) => {
              // email check
              const patternEmail =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return patternEmail.test(val) || "Invalid e-mail.";
            },
            (val) => !!val || "This field is required",
          ],
          Tel1: [(val) => !!val || "This field is required"],
          Ext_number1: [],
          TitleName_th2: [],
          Name_th2: [],
          LastName_th2: [],
          Position_th2: [],
          TitleName_en2: [],
          Name_en2: [],
          LastName_en2: [],
          Position_en_2: [],
          Email2: [],
          Tel2: [],
          Ext_number2: [],
          TitleName_th3: [],
          Name_th3: [],
          LastName_th3: [],
          Position_th3: [],
          TitleName_en3: [],
          Name_en3: [],
          LastName_en3: [],
          Position_en_3: [],
          Email3: [],
          Tel3: [],
          Ext_number3: [],
          // Step4
          Id: [],
          Share_thai: [val => (!!val) || 'This field is required', val => ((val >= 0 && val <= 100) ) || 'Number has to be between 0 and 100%'],
          Share_foreign: [val => ((val >= 0 && val <= 100) ) || 'Number has to be between 0 and 100%'],
          Nationshare: [(val) => !!val || "This field is required"],
          Original_com: [(val) => !!val || "This field is required"],
          Business_Title: [(val) => !!val || "This field is required"],
          Tier_Title: [(val) => !!val || "This field is required"],
          Related_industry: [(val) => !!val || "This field is required"],
          Related_other: [],
          Process: [],
          Process_other: [],
          Product_type: [],
          Product_type_other: [],
          Quality_system: [],
          Quality_system_other: [],
          Main_product1: [],
          item1: [],
          Main_product2: [],
          item2: [],
          Main_product3: [],
          item3: [],
          Domestic: [],
          Export: [],
          Export_country: [],
          Main_domestic: [],
          Main_foreign: [],
          Staff: [(val) => !!val || "This field is required"],
          Register_capital: [(val) => !!val || "This field is required"],
          Paid_capital: [(val) => !!val || "This field is required"],
          Tai_activity: [(val) => !!val || "This field is required"],
          Tai_activity_other: [],
          // Step5
          agree: [val => (!!val) || 'This field is required'],
          accepted: [val => (!!val) || 'This field is required'],
              // val => (!!val) || 'This field is required',
              // val => (!!val.toString()) || 'ห้ามเป็นค่าว่าง',
              // val => (val && val.length >= 3) || 'ต้องมีอย่างน้อย 3 ตัวอักษร',
              // val => (((val.length || 0) <= 500) ) || 'ต้องไม่เกิน 500 ตัวอักษร',
              // val => (!val.trim() || !isNaN((val)) ) || 'ต้องเป็นตัวเลข',
              // val => (Number.isInteger(parseFloat(val) ) ) || 'ต้องเป็นจำนวนเต็ม',
              // val => ((val >= 0 && val <= 999) ) || 'Number has to be between 0 and 999',

              // val => { // email check
              //   const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              //   return patternEmail.test(val) || 'Invalid e-mail.'
              // },            
        },
        // rules: {
        // },
        //data()
    }
  },
  methods: {
    // 
    formatInput() {
      if (this.itemSelected.Staff !== null) {
        // Remove commas and convert to a number
        let num = parseFloat(this.itemSelected.Staff.toString().replace(/,/g, ''));

        // Format the number with commas
        this.itemSelected.Staff = num.toLocaleString('en-US');
      }
      if (this.itemSelected.Register_capital !== null) {
        // Remove commas and convert to a number
        let num = parseFloat(this.itemSelected.Register_capital.toString().replace(/,/g, ''));

        // Format the number with commas
        this.itemSelected.Register_capital = num.toLocaleString('en-US');
      }
      if (this.itemSelected.Paid_capital !== null) {
        // Remove commas and convert to a number
        let num = parseFloat(this.itemSelected.Paid_capital.toString().replace(/,/g, ''));

        // Format the number with commas
        this.itemSelected.Paid_capital = num.toLocaleString('en-US');
      }
    },
    // 
    updateShareForeign() {
      const thaiShare = parseFloat(this.itemSelected.Share_thai) || 0;
      this.itemSelected.Share_foreign = (100 - thaiShare).toFixed(2);
    },
    updateShareThai() {
      const foreignShare = parseFloat(this.itemSelected.Share_foreign) || 0;
      this.itemSelected.Share_thai = (100 - foreignShare).toFixed(2);
    },
    // 
    handleThaiTitleInput0() {
      const thaiTitle = this.itemSelected.TitleName_th0;
      const index = this.TitleName_th0.indexOf(thaiTitle);

      if (index !== -1) {
        this.itemSelected.TitleName_en0 = this.TitleName_en0[index];
      }
    },
    handleThaiTitleInput1() {
      const thaiTitle = this.itemSelected.TitleName_th1;
      const index = this.TitleName_th1.indexOf(thaiTitle);

      if (index !== -1) {
        this.itemSelected.TitleName_en1 = this.TitleName_en1[index];
      }
    },
    handleThaiTitleInput2() {
      const thaiTitle = this.itemSelected.TitleName_th2;
      const index = this.TitleName_th2.indexOf(thaiTitle);

      if (index !== -1) {
        this.itemSelected.TitleName_en2 = this.TitleName_en2[index];
      }
    },
    handleThaiTitleInput3() {
      const thaiTitle = this.itemSelected.TitleName_th3;
      const index = this.TitleName_th3.indexOf(thaiTitle);

      if (index !== -1) {
        this.itemSelected.TitleName_en3 = this.TitleName_en3[index];
      }
    },

    // Start send mail
    async itemNotify(item) {
      let emailEnable = (this.env === 'production')
      let lineEnable = (this.env === 'production')
      let baseURL
      if (process.env.NODE_ENV === 'production') {
        baseURL = window.location.protocol + process.env.VUE_APP_API_PATH + 'tai_book/'
      } else {
        baseURL = window.location.protocol + '//' + window.location.host + '/'
      }      
      let empNamePR = this.$options.filters.empName(item.EmpCode, this.allPerson, 'คุณ') 
      let notifyEmpCode = []
      let empNameAppv = ''
      let title = 'สมาชิกสถาบันเลขที่: '
      let titleFooter = ''
      let toEmp = ''
      let ETotal = 0.00
      let link = ''
      title = '\n วันที่ขอ: ' + this.$options.filters.datetime(item.DocDate)
      title += '\n เลขที่: ' + item.DocCode
      title += '\n ผู้ขอ: ' + empNamePR  
      title += '\n เรื่อง: ' + item.topic
      if(item.message) {
        title += '\n ' + item.message
      }
      title += '\n\n โดยสามารถคลิกจากลิงค์ด้านล่างนี้ เพื่อดูรายละเอียด\n\n ' + link 
      if(this.checkPermission(['admin'])) {
        alert(title)
      }
      let data = {
        emp: toEmp,
        message:title
      }
      let dataEmail = {
        subject: titleFooter + '[' + item.DocCode + ']' + ' ยอดรวมทั้งสิ้น:' + ETotal,
        emp: toEmp,
        message:title + '\n\n ' + "<a href='" + link + "'>คลิกที่นี่</a>"
      }
      for(let i = 0; i < notifyEmpCode.length; i++){
        if(!emailEnable&&!lineEnable){
          alert(this.env + ' '  + notifyEmpCode[i] +'\n\n'+ title)
        }
        if(emailEnable && notifyEmpCode[i] !== 'user_ad'){
          dataEmail.emp = notifyEmpCode[i] 
          userService.emailnotify(dataEmail).then(res => {
            // console.log('linenotify ok', res)
            if(res.status !== 200){
              alert('ไม่สามารถส่งแจ้งเตือนได้ \n' + res.message + '\n\n' + data.emp )
            }
          }).catch(err => {
            console.log('linenotify err', err)
          })
        }
        if(lineEnable){
          data.emp = notifyEmpCode[i]
          userService.linenotify(data).then(res => {
            // console.log('linenotify ok', res)
            if(res.status !== 200){
              alert('ไม่สามารถส่งแจ้งเตือนได้ \n' + res.message + '\n\n' + data.emp)
            }
          }).catch(err => {
            console.log('linenotify err', err)
          })
        }
      }

      // await this.$refs.pdfItem.downloadPDF(item)
    },
    async AppvMessage() {
      // this.$refs.otp.appl = this.$store.state.users.main.empCode + this.itemSelected.DocCode 
      
      let payload = {
        from :'สถาบันยานยนต์',
         to :this.itemSelected.Email,
         cc :'',
         bcc :'marketing@thaiauto.or.th',
        //  bcc :'kampee@thaiauto.or.th',
         subject :'การสมัครสมาชิกสถาบันยานยนต์',
         htmlBody:'เรียน&nbsp;'+ this.itemSelected.Member_Title+ '&nbsp;' 
          // +this.itemSelected.Name_Com_th+'&nbsp;&nbsp;เลขที่สมาชิก'+ '&nbsp;'+ this.itemSelected.MemberCode
          +this.itemSelected.Name_Com_th
          +'<br><br>ขอขอบพระคุณเป็นอย่างสูงที่สมัครสมาชิกสถาบันยานยนต์ <br>สถาบันยานยนต์ได้รับข้อมูลการสมัครสมาชิกฯ ของท่านเป็นที่เรียบร้อยแล้ว<br>โดยเจ้าหน้าที่จะทำการตรวจสอบข้อมูล และออกจดหมายรับรองการเป็นสมาชิกสถาบันยานยนต์ ให้หน่วยงานของท่านต่อไป<br>'
          +'<p style="margin-bottom: 5px; color:#362FD9; font-weight: bold;">Best regards,</p><br>'
          +'<p style="font-family: Arial;font-size: 12px;">'
          +'Thailand Automotive Institute<br>'
          +'4th Floor , Bureau of Industrial Sectors Development Building<br>'
          +'Soi Trimitr , Kluaynamthai , Rama IV Road, Klongtoey, Bangkok 10110 , Thailand<br>'
          +'Tel: +662 712 2414<br>'
          +'Fax: +662 712 2415'
          +'</p>'
          +'<p style="font-weight: bold; margin-top: 0px; ">'
          +'<a href="https://www.thaiauto.or.th/2020" style="text-decoration: none" target="_blank">www.thaiauto.or.th</a>'
          +'&nbsp;<a href="https://www.facebook.com/ThailandAutomotiveInstitute" class="image-link" target="_blank"><img src="https://lh3.googleusercontent.com/d/1VkHByEuui_aWvkxDkPcnyY1mz2gQKPpx=s220" height="24" alt="..." class="card-img-top"></a>'
          +'&nbsp;<a href="https://www.youtube.com/user/ThailandAutomotive" class="image-link"  target="_blank"><img src="https://lh3.googleusercontent.com/d/1MmkFPfVd0fKJlT2zjTx8GeJEP5uuB9Rw=s220" width="26" height="24" alt="..." class="card-img-top"></a>'
          +'&nbsp;<a href="https://twitter.com/Thai_Auto" class="image-link"  target="_blank"><img src="https://lh3.googleusercontent.com/d/1-12WDtNdEuodCG9pObIWjccinPN43GpZ=s220" height="24" alt="..." class="card-img-top"></a>'
          +'&nbsp;<a href="https://lin.ee/xZJvgDI" class="image-link"  target="_blank"><img src="https://lh3.googleusercontent.com/d/1Qtbps-iDzET8GgazaLEdE2hnm_66twQ4=s220" height="24" alt="..." class="card-img-top"></a>'
          +'</p>'
          +'<p><a href="https://www.thaiauto.or.th/2020" class="image-link"  target="_blank"><img src="https://lh3.googleusercontent.com/d/1rVDDua5rwXfO4LX2s4M0cePhq-6TSKuT" width="230" alt="..." class="card-img-top" style="margin-top: 0px;"></a></p>'
         ,
        ReplyTo:'noreply@thaiauto.or.th'
      }
  
      let response = await itemService.sendMail(payload);

    },
    // End send mail
    async previewShow(item){
      console.log('previewShow')
      this.Save()
      this.Save2()
      this.Save3()
      this.pdfdata = item
      item = {...item, ...this.Memberall}, // ดึง Field จาก MemberPart1
      this.pdfdata = {...this.pdfdata, ...this.Memberall}, // ดึง Field จาก MemberPart2
      // this.pdfdata = {...this.pdfdata, ...this.MemberPart2}, // ดึง Field จาก MemberPart2
      // this.pdfdata = {...this.pdfdata, ...this.Quiz}, // ดึง Field จาก Quit
      await this.$refs.pdfItem.downloadPDF(this.pdfdata)
      console.log(this.$refs.pdfItem)
    },
    stepComplete(step) {
      return this.curr > step;
    },
    stepStatus(step) {
      return this.curr > step ? "green" : "blue";
    },
    validate(n) {
      this.steps[n].valid = false;
      let v = this.$refs.stepForm[n].validate();
      console.log('validate(n):' , n)
      if (v) {
        this.steps[n].valid = true;
        // continue to next
        this.curr = n + 1;
        if(n<3){
          if (this.action ==='add') {
            this.Save()
            this.action ='edit'
          } else {
            this.Save()
            
          }
        }
        if(n>2 && n <5) {
          // 1. ลิงค์ MemberCode
          // this.itemSelected2.MemberCode = this.itemSelected.MemberCode
          //2. ไปสร้าง function save2() ซึ่งภายในให้ส่ง payload ดป็น Itemselected2 และ รับคือค่า
          // this.savememberpart2()
          
          this.Save2()

        }
        if(n>3 && n <5) {
          // 1. ลิงค์ MemberCode
          // this.itemSelected2.MemberCode = this.itemSelected.MemberCode
          //2. ไปสร้าง function save2() ซึ่งภายในให้ส่ง payload ดป็น Itemselected2 และ รับคือค่า
          // this.savememberpart2()
          this.Save3()

        }

      }
    },
    done() {
      this.curr = 6;
    },
    formatAsCurrency(value, dec) {
      dec = dec || 0;
      if (value === null) {
        return 0;
      }
      return "" + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    async Save() {
      this.loading = true;
      // this.itemSelected.MemberCode = this.itemSelected.MemberCode
      console.log("memberall Save 1");    
      this.itemSelected.InsertDate = this.$store.getters.nowString;
      
      // var modifyDate = new Date().toISOString().slice(0, 19);
      // this.itemSelected.ModifyDate = modifyDate;
      
      // ทำ convert string
      // this.itemSelected.Member_Title = this.Member_Title.join('|||')
      if (this.action !== "add") {
        // Update Event
        console.log("memberall Save Update");
        let response = await itemService.memberallUpdate(this.itemSelected);
        console.log("memberall Save Update then");
        if (response.data.error === "") {
          console.log("memberall Save Update then OK");
          this.itemSelected = response.data.data[0];
          // this.itemSelected.Member_Title = this.Member_Title.split('|||')
          // let itemSelected_update = response.data.data[0]; // this.itemSelected
          // this.$emit("update", itemSelected_update);
          this.loading = false;
          return true;
        } else {
          console.log("memberall Save Update then error");
          alert("!!เกิดข้อผิดพลาด\n" + response.data.error);
          this.loading = false;
          return false;
        }
      } else {
        // Insert Event
        console.log("memberall Save Insert");
        // let response = await itemService.memberallInsert(this.itemSelected);
        let response = await itemService.memberpart1Insert(this.itemSelected);
        console.log("memberall Save Insert then ");
        if (response.data.error === "") {
          console.log("memberall Save Insert then OK");
          this.itemSelected = response.data.data[0]
          // this.itemSelected.Member_Title = this.Member_Title.split('|||')
          // let itemSelected = response.data.data[0]; // this.itemSelected
          // this.$emit("update", itemSelected);
          this.loading = false;
          return true;
        } else {
          console.log("memberall Save Insert then Error");
          alert("!!เกิดข้อผิดพลาด\n" + response.data.error);
          this.loading = false;
          return false;
        }
      }
    },
    async Save2() {
      this.loading = true;
      this.itemSelected.MemberCode = this.itemSelected.MemberCode
      this.itemSelected.TradeCode = this.itemSelected.TradeCode // เพิ่มตัว field ที่เหมือนกันใน database
      console.log("memberall Save 2 memberpart2");
      
      this.itemSelected.InsertDate = this.$store.getters.nowString;
      // var modifyDate = new Date().toISOString().slice(0, 19);
      // this.itemSelected.ModifyDate = modifyDate;

      // Update Event
      console.log("memberall Save2 Update");
      let response = await itemService.memberallUpdate(this.itemSelected);
      console.log("memberall Save2 Update then");
      if (response.data.error === "") {
        console.log("memberall Save2 Update then OK");
        this.itemSelected = response.data.data[0];
        // let itemSelected_update = response.data.data[0]; // this.itemSelected
        // this.$emit("update", itemSelected_update);
        this.loading = false;
        return true;
      } else {
        console.log("memberall Save2 Update then error");
        alert("!!เกิดข้อผิดพลาด\n" + response.data.error);
        this.loading = false;
        return false;
      }
    },
    
    async Save3() {
      this.loading = true;
      this.itemSelected.MemberCode = this.itemSelected.MemberCode
      this.itemSelected.TradeCode = this.itemSelected.TradeCode // เพิ่มตัว field ที่เหมือนกันใน database
      console.log("memberall Save 3 quiz");
      this.itemSelected.InsertDate = this.$store.getters.nowString;
      // var modifyDate = new Date().toISOString().slice(0, 19);
      // this.itemSelected.ModifyDate = modifyDate;
      // 1. ทำ convert string
      this.itemSelected.Business_Title = this.Business_Title.join(', ');
      this.itemSelected.Tier_Title = this.Tier_Title.join(', ');
      this.itemSelected.Related_industry = this.Related_industry.join(', ');
      this.itemSelected.Tai_activity = this.Tai_activity.join(', ');
      // Update Event
      console.log("memberall Save3 Update");
      let response = await itemService.memberallUpdate(this.itemSelected);
      console.log("memberall Save3 Update then");
      if (response.data.error === "") {
        console.log("memberall Save3 Update then OK");
        this.itemSelected = response.data.data[0];
        // 2. ทำ convert string
        this.itemSelected.Business_Title = this.Business_Title //.split('|||');
        this.itemSelected.Tier_Title = this.Tier_Title //.split('|||');
        this.itemSelected.Related_industry = this.Related_industry //.split('|||');
        this.itemSelected.Tai_activity = this.Tai_activity //.split('|||');
        // let itemSelected_update = response.data.data[0]; // this.itemSelected
        // this.$emit("update", itemSelected_update);
        this.loading = false;
        return true;
      } else {
        console.log("memberall Save3 Update then error");
        alert("!!เกิดข้อผิดพลาด\n" + response.data.error);
        this.loading = false;
        return false;
      }
    },

    // PersonInput Component สำคัญ
    // person_error(e) {
    //     console.log('person_error', e)
    // },
      test: function() {
        // console.log('update:search-input')
     },
      formatValue: function () {
        // console.log('label', this.label)
        // console.log('formatValue-01', this.value)
        if (this.value) {
          this.Business_Title = this.value.trim().join().map(m=> {m.trim(); return m})
        } else {
          this.Business_Title = []
        }

        // this.formatted = this.Date2Text(this.value)
        // this.$refs.Input.value = this.Date2Text(this.value)
        // console.log('formatValue-03  ok', this.Member_Title)
      },
      getName: function (code) {
        return this.BusinessOption.filter((p) => {
          if (p.code === code) return p
        })[0]
      },
      getName: function (code) {
        return this.TierTitleOption.filter((p) => {
          if (p.code === code) return p
        })[0]
      },
      getName: function (code) {
        return this.RelatedindustryOption.filter((p) => {
          if (p.code === code) return p
        })[0]
      },
      getName: function (code) {
        return this.TaiactivityOption.filter((p) => {
          if (p.code === code) return p
        })[0]
      },

    // method
  },
    watch: {
      // autoclice  when curr=6
      curr(newVal) {
        if (newVal === 6) {
          this.AppvMessage();
        }
      },
    // add 100%
    'itemSelected.Share_thai': 'updateShareForeign',
    'itemSelected.Share_foreign': 'updateShareThai',
      // 'itemSelected.Share_thai': function(newShareThai) {
      //   // this.itemSelected.Share_foreign = (100 - newShareThai).toFixed(0);
      //   this.itemSelected.Share_foreign = 100 - newShareThai;
      // },
      // 'itemSelected.Share_foreign': function(newShareForeign) {
      //   // this.itemSelected.Share_thai = (100 - newShareForeign).toFixed(2);
      //   this.itemSelected.Share_thai = 100 - newShareForeign;
      // },
    // same value in differnce field
    'itemSelected.AddressNumber_th': function(newVal) {
      // Update the value of AddressNumber_en whenever AddressNumber_th changes
      this.itemSelected.AddressNumber_en = newVal;
    },
    'itemSelected.AddressNumber_en': function(newVal) {
      // Update the value of AddressNumber_th whenever AddressNumber_en changes
      this.itemSelected.AddressNumber_th = newVal;
    },
    'itemSelected.Moo_th': function(newVal) {
      // Update the value of Moo_en whenever Moo_th changes
      this.itemSelected.Moo_en = newVal;
    },
    'itemSelected.Moo_en': function(newVal) {
      // Update the value of Moo_th whenever Moo_en changes
      this.itemSelected.Moo_th = newVal;
    },
    'itemSelected.Zipcode': function(newVal) {
      // Update the value of AddressNumber_en whenever AddressNumber_th changes
      this.itemSelected.Zipcode1 = newVal;
    },
    'itemSelected.Zipcode1': function(newVal) {
      // Update the value of AddressNumber_th whenever AddressNumber_en changes
      this.itemSelected.Zipcode = newVal;
    },

    // 
    itemSelected: function(value, oldValue) {
      this.$nextTick(() => {
        console.log(value)
        if (value.MemberCode !== oldValue.MemberCode){
          console.log('change Key')
          this.initLoad()
        }
      })
    },
    formValid: function(value) {
      this.$emit('valid', value)
    },

    //watch()
  },

  computed: {
    // 
    initialPaidFormatted: {
      get: function () {
        if(this.itemSelected.Paid_capital){
          return this.formatAsCurrency(this.itemSelected.Paid_capital, 0);
        }else{
          return this.formatAsCurrency(0, 0);
        }
      },
      
      set: function (newValue) {
        this.itemSelected.Paid_capital = Number(newValue.replace(/[^0-9\.]/g, ""));
      },
    },
    initialBalanceFormatted: {
      get: function () {
        if(this.itemSelected.Register_capital){
          return this.formatAsCurrency(this.itemSelected.Register_capital, 0);
        }else{
          return this.formatAsCurrency(0, 0);
        }
        
      },
      
      set: function (newValue) {
        this.itemSelected.Register_capital = Number(newValue.replace(/[^0-9\.]/g, ""));
      },
      
    },
    // PersonInput Component
    BusinessTitles: function() {
        return this.BusinessOption
    },
    TierTitles: function() {
        return this.TierTitleOption
    },
    Relatedindustrys: function() {
        return this.RelatedindustryOption
    },
    Taiactivitys: function() {
        return this.TaiactivityOption
    },



      componentError() {
        try{
          let r = this.$refs.textvaridate.valid
          return !!r
        }catch(e){
          return false
        }
      },

     //computed()
  },
  mounted: function() {
    this.initLoad()

    //mounted()
  },

};
</script>
<style>
.small-radio i {
  font-size: 15px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*="__ripple"] {
  left: -9;
}
/* term */
.tacbox {
  display:block;
  padding: 1em;
  margin: 2em;
  border: 3px solid #ddd;
  background-color: #eee;
  max-width: 800px;
}

input {
  height: 2em;
  width: 2em;
  vertical-align: middle;
}
ol { counter-reset: item }
li{ display: block }
li:before { content: counters(item, ".") " "; counter-increment: item }

</style>
